
<template>

	<mymodal ref="modal" title="Добавить корректировку" ok="Применить" :reset="reset" :ok_disabled="!check" :submit="submit" width="800px">
		<b-form-radio-group v-model="type" :options="options" class="mb-2" />

        <v-select v-if="type == 'Корректировка по ценообразующему фактору'" id="select_attr" placeholder="Ценообразующий фактор"
			v-model="attr_id" :reduce="obj => obj.id" label="name" :options="attrs_visible" :clearable="false"
			class="p-1" appendToBody appendToParent
		/>

		<div v-else class="p-1"><b-form-input v-model="name" :formatter="formatter" placeholder="Наименование корректировки" size="sm" /></div>

	</mymodal>

</template>

<script>

import attrs from "../../../../../../api/attrs";
import mymodal from "../../../../../widgets/modal"

export default
{
	components :
	{
		mymodal,
	},

	data()
	{
		return {
			attrs_visible : null,
			
			options : [ "Корректировка по ценообразующему фактору", "Произвольная корректировка" ],
			type : "Корректировка по ценообразующему фактору",

            attr_id : null,
			name : null
		}
	},

	watch :
	{
		type()
		{
			this.attr_id = null
			this.name = null
		}
	},

	computed :
	{
		check()
		{
			return this.type == "Корректировка по ценообразующему фактору"
				? this.attr_id
				: this.name
		},
	},

	methods :
	{
		reset()
		{
			this.type = "Корректировка по ценообразующему фактору"
			this.attr_id = null
			this.name = null
		},

		formatter(value)
		{
			if (value.match(/^\s+/) || value.match(/\s+$/) || value?.length > 200)
			{
				return this.name
			}
			else
			{
				return value
			}
		},

		execute(showed_attrs)
		{
			attrs.get(this).then((res) => {
				this.attrs_visible = res.attrs.filter(attr => showed_attrs.includes(attr.id))

				this.$refs.modal.execute()
			})
		},

		submit()
		{
			const value = this.type == "Корректировка по ценообразующему фактору" ? { attr_id : this.attr_id } : { name : this.name }
			this.$emit("add_attr", value)
		}
	}
}

</script>
